/* eslint-disable react/jsx-props-no-spreading */
import { FC, ReactNode, RefAttributes } from 'react'
import { RowDataType, RowKeyType, Cell as RsuiteCell } from 'rsuite-table'
import { InnerCellProps } from 'rsuite-table/lib/Cell'
import { Whisper, Tooltip } from 'rsuite'

type Props = InnerCellProps<RowDataType<any>, RowKeyType> &
  RefAttributes<HTMLDivElement> & {
    /**
     * Tooltip content. Pass a string for a static label, a function for
     * per-row content, or any ReactNode (e.g. a bulleted list). When omitted
     * the cell auto-derives text from dataKey. Pass an empty string `""` to
     * explicitly suppress the tooltip.
     */
    tooltip?: ReactNode | ((rowData: any) => ReactNode);
  }

const Cell: FC<Props> = ({ dataKey, rowData, tooltip, children, ...props }: Props) => {
  const autoText = rowData && dataKey ? String(rowData[dataKey] ?? '') : ''

  let tooltipContent: ReactNode
  if (typeof tooltip === 'function') {
    tooltipContent = rowData ? tooltip(rowData) : ''
  } else {
    tooltipContent = tooltip !== undefined ? tooltip : autoText
  }

  const cell = (
    <RsuiteCell dataKey={dataKey} rowData={rowData} {...props}>
      {children}
    </RsuiteCell>
  )

  if (!tooltipContent) return cell

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{tooltipContent}</Tooltip>}
    >
      {cell}
    </Whisper>
  )
}

export default Cell
